import { render, staticRenderFns } from "./AppMangement.vue?vue&type=template&id=b5dc979e&scoped=true&"
import script from "./AppMangement.vue?vue&type=script&lang=js&"
export * from "./AppMangement.vue?vue&type=script&lang=js&"
import style0 from "./AppMangement.vue?vue&type=style&index=0&id=b5dc979e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dc979e",
  null
  
)

export default component.exports